import { useRef } from "react";
import {
  buildEmptyOption,
  isDefaultOptionLabel
} from "../utils/choiceQuestionUtils";

export default function useChoiceOptions(question, onUpdate) {
  const inputRefs = useRef([]);

  const options =
    question.options && question.options.length > 0
      ? question.options
      : [buildEmptyOption(), buildEmptyOption()];

  const handleOptionChange = (optionIndex, value) => {
    const newOptions = [...options];
    newOptions[optionIndex] = {
      ...newOptions[optionIndex],
      label: value
    };

    onUpdate?.({ options: newOptions });
  };

  const handleAddOption = () => {
    const newOptions = [...options, buildEmptyOption()];

    onUpdate?.({ options: newOptions });

    setTimeout(() => {
      const nextIndex = newOptions.length - 1;
      inputRefs.current[nextIndex]?.focus();
    }, 0);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddOption();
    }
  };

  const getInputValue = (option, optionIndex) => {
    return isDefaultOptionLabel(option.label, optionIndex)
      ? ""
      : option.label || "";
  };

  return {
    options,
    inputRefs,
    handleOptionChange,
    handleAddOption,
    handleKeyDown,
    getInputValue
  };
}